export enum FilterOperator {
	EQUALS,
	STARTSWITH,
	ENDSWITH,
	LIKE,
	GREATEROREQUALTHAN,
	GREATERTHAN,
	SMALLEROREQUALTHAN,
	SMALLERTHAN,
	ISNOTIN
}
